import { render, staticRenderFns } from "./AgencyVolunteerProfileCard.vue?vue&type=template&id=6d8cc544&scoped=true"
import script from "./AgencyVolunteerProfileCard.vue?vue&type=script&lang=js"
export * from "./AgencyVolunteerProfileCard.vue?vue&type=script&lang=js"
import style0 from "./AgencyVolunteerProfileCard.vue?vue&type=style&index=0&id=6d8cc544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8cc544",
  null
  
)

export default component.exports